export default __webpack_public_path__ + "static/media/unity.b196c776.png";